import { render, staticRenderFns } from "./SettingsVerification.vue?vue&type=template&id=dcab1630&scoped=true&"
import script from "./SettingsVerification.vue?vue&type=script&lang=js&"
export * from "./SettingsVerification.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVerification.vue?vue&type=style&index=0&id=dcab1630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcab1630",
  null
  
)

export default component.exports